import { ApprovedHousingComplex } from './approved-housing-complex.model';

export class ApprovedAddress {
    complex: ApprovedHousingComplex;
    fullAddress: string;
    addressWithoutApartment: string;
    apartmentNumber?: number;
    apartmentLetter: string;
    actualResidents?: number;
    totalResidents?: number;
}
